import type { RequestFormProps } from "../_model";
import { send_request } from "../apis";
import { createRequestFromInputs } from "../forms";
import { global } from ":shared/app";

export function RequestForm(props: RequestFormProps) {
  const FormInputs = createRequestFromInputs();

  async function onSubmit(e: Event) {
    const values = FormInputs.Actions.getValuesSnakecase();
    values["issue_type"] = props.issue_type;
    console.log("values as payload:: ", JSON.stringify(values));
    return send_request(JSON.stringify(values)).then(() => {
      props.triggers?.onSubmitted?.();
      global.store.actions.toast.pushToast({
        type: "success",
        message: "Request Sent, we'll be with you shortly inshallah",
      });
    });
  }

  return (
    <div class="flex flex-col w-50% h-fit px-2 py-3 items-center justify-center self-center <sm:(!w-full)">
      <h1 class="text-center font-bold text-black text-26px">Request On-Site Help</h1>
      <button
        onclick={() => {
          global.store.actions.toast.pushToast({
            type: "error",
            message: "wow so message",
          });
        }}
      >
        click
      </button>
      <p class="text-center py-2 font-[500] text-black text-18px">
        Enter your information details so we can reach you out 😄
      </p>

      <form class="grid grid-cols-[30%_70%] h-fit gap-2 <sm:(w-full grid-cols-1 gap-0)">
        <FormInputs.TableNumber.Label title="Table Number" class="form-label">
          <FormInputs.TableNumber.Select options={props?.tables_range} class="form-select" placeholder="wow" />
        </FormInputs.TableNumber.Label>

        <FormInputs.Mobile.Label
          title="Phone Number"
          class="form-label"
          note="will help us find you if you change your table"
        >
          <FormInputs.Mobile.Input type="tel" class="form-input" placeholder="05xxxxxxxx" />
        </FormInputs.Mobile.Label>

        <FormInputs.Description.Label title="Describe your issue " class="form-label sm:col-span-2 ">
          <FormInputs.Description.TextArea
            autocomplete="Describe your issue"
            class="form-textarea"
            placeholder="please describe your problem in either arabic or english and be as specific as possible"
          />
        </FormInputs.Description.Label>
      </form>
      <div class="flex w-full sm:(!w-40% col-span-2 self-end justify-end items-end)">
        <FormInputs.Actions.Button
          class="form-btn "
          onclick={onSubmit}
          statusValid={"Submit Request"}
          statusInvalid={"Submit Request"}
        />
      </div>
    </div>
  );
}
